import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../AppProvider";
import { faLoader } from "../../../utilities/fontawesomeIcons";
import { useInView } from "react-intersection-observer";
import { useEffect, useMemo } from "react";
import { useFeedbacksStatisticsContext } from "../providers/FeedbacksRatings";
import Rating from "../../../Components/Rating/Rating";
import { getColorByValue } from "../../../Components/Rating/utilities";
import moment from "moment";

const FeedbacksStatistics = () => {
  const { dictionary } = useAppContext();
  const { data, loader, filters } = useFeedbacksStatisticsContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  const colors = data?.ratings?.map((d) =>
    getColorByValue(d.value, data?.ratings?.length)
  );

  const initialValue = 0;

  /** Total number of feedbacks */
  const totalAmount =
    data?.ratings?.reduce(
      (accumulator, currentValue) => accumulator + currentValue.amount,
      initialValue
    ) || 0;

  /** Weighted sum of ratings */
  const weightedSum =
    data?.ratings?.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue.value * currentValue.amount,
      initialValue
    ) || 0;

  /** Average rating value */
  const averageRating = weightedSum / totalAmount;

  /**
   * Memoized Bar chart component to prevent unnecessary re-renders.
   */
  const barContent = useMemo(() => {
    if (!inView || !data?.ratings?.length) return null;

    const dataToDisplay = {
      labels: data.ratings.map((d) => d.value),
      datasets: [
        {
          data: data.ratings.map((d) => d.amount),
          backgroundColor: colors,
          maxBarThickness: 40,
        },
      ],
    };

    return (
      <Bar
        className="mt-2"
        data={dataToDisplay}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: dictionary.feedbacks.ratings,
              },
            },
            y: {
              beginAtZero: true,
              min: 0,
              ticks: {
                stepSize: 1,
              },
              title: {
                display: true,
                text: dictionary.feedbacks.total_feedbacks,
              },
            },
          },
        }}
      />
    );
  }, [inView, data, colors]);

  return (
    <div ref={ref} className="box-container text-center h-100">
      <div className="row mb-1" style={{ height: "60px" }}>
        <div className="col">
          <label className="label-4 lh-1 mb-1">
            {dictionary.feedbacks.feedback_ratings}
          </label>
          <label className="label-2">
            {moment(filters.start).isSame(moment(filters.end), "day")
              ? moment(filters.start).format("DD/MM/YYYY")
              : moment(filters.start).format("DD/MM/YYYY") +
                " - " +
                moment(filters.end).format("DD/MM/YYYY")}
          </label>
        </div>
      </div>

      <div className="row">
        <div className="col">
          {loader ? (
            <FontAwesomeIcon icon={faLoader} spin size="4x" />
          ) : data?.ratings ? (
            <div
              style={{ width: "100%", height: "450px", position: "relative" }}
            >
              <div className="d-flex justify-content-center ">
                <Rating value={Number(averageRating.toFixed(1))} />
              </div>
              {barContent}
            </div>
          ) : (
            <label className="label-3">
              {dictionary.messages.no_results_found}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeedbacksStatistics;
